import _definePage_default_0 from 'C:/source/faraadid/Frontend/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'C:/source/faraadid/Frontend/src/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from 'C:/source/faraadid/Frontend/src/pages/access-control.vue?definePage&vue'
import _definePage_default_4 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/chat/[id].vue?definePage&vue'
import _definePage_default_5 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/chat/only-charts/[id].vue?definePage&vue'
import _definePage_default_6 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/connect-to-database/[id].vue?definePage&vue'
import _definePage_default_7 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/connect-to-service/[id].vue?definePage&vue'
import _definePage_default_8 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/conversation/[id].vue?definePage&vue'
import _definePage_default_9 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/dashboard/[id].vue?definePage&vue'
import _definePage_default_10 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/files/[id].vue?definePage&vue'
import _definePage_default_11 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/files/list/[id].vue?definePage&vue'
import _definePage_default_12 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/list/index.vue?definePage&vue'
import _definePage_default_13 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/monitoring/[id].vue?definePage&vue'
import _definePage_default_14 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/monitoring/list/[id].vue?definePage&vue'
import _definePage_default_15 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/my-dashboard/[id].vue?definePage&vue'
import _definePage_default_16 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/my-dashboard/list/[id].vue?definePage&vue'
import _definePage_default_17 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/settings/[id].vue?definePage&vue'
import _definePage_default_18 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/teaching/[id].vue?definePage&vue'
import _definePage_default_19 from 'C:/source/faraadid/Frontend/src/pages/apps/bot/teaching/list/[id].vue?definePage&vue'
import _definePage_default_20 from 'C:/source/faraadid/Frontend/src/pages/apps/chat/index.vue?definePage&vue'
import _definePage_default_21 from 'C:/source/faraadid/Frontend/src/pages/apps/conversation/list/index.vue?definePage&vue'
import _definePage_default_22 from 'C:/source/faraadid/Frontend/src/pages/apps/dashboard/index.vue?definePage&vue'
import _definePage_default_23 from 'C:/source/faraadid/Frontend/src/pages/apps/database-connection-data/list/index.vue?definePage&vue'
import _definePage_default_24 from 'C:/source/faraadid/Frontend/src/pages/apps/database-connection-data/view/[id].vue?definePage&vue'
import _definePage_default_25 from 'C:/source/faraadid/Frontend/src/pages/apps/database-type/list/index.vue?definePage&vue'
import _definePage_default_26 from 'C:/source/faraadid/Frontend/src/pages/apps/database-type/view/[id].vue?definePage&vue'
import _definePage_default_27 from 'C:/source/faraadid/Frontend/src/pages/apps/feedback/list/index.vue?definePage&vue'
import _definePage_default_28 from 'C:/source/faraadid/Frontend/src/pages/apps/file/list/index.vue?definePage&vue'
import _definePage_default_29 from 'C:/source/faraadid/Frontend/src/pages/apps/llm/list/index.vue?definePage&vue'
import _definePage_default_30 from 'C:/source/faraadid/Frontend/src/pages/apps/message/list/index.vue?definePage&vue'
import _definePage_default_31 from 'C:/source/faraadid/Frontend/src/pages/apps/monitoring/index.vue?definePage&vue'
import _definePage_default_32 from 'C:/source/faraadid/Frontend/src/pages/apps/notification/list/index.vue?definePage&vue'
import _definePage_default_33 from 'C:/source/faraadid/Frontend/src/pages/apps/permissions/index.vue?definePage&vue'
import _definePage_default_34 from 'C:/source/faraadid/Frontend/src/pages/apps/roles/index.vue?definePage&vue'
import _definePage_default_35 from 'C:/source/faraadid/Frontend/src/pages/apps/settings/list/index.vue?definePage&vue'
import _definePage_default_36 from 'C:/source/faraadid/Frontend/src/pages/apps/user/list/index.vue?definePage&vue'
import _definePage_default_37 from 'C:/source/faraadid/Frontend/src/pages/apps/user/view/[id].vue?definePage&vue'
import _definePage_default_38 from 'C:/source/faraadid/Frontend/src/pages/change-password.vue?definePage&vue'
import _definePage_default_39 from 'C:/source/faraadid/Frontend/src/pages/forgot-password.vue?definePage&vue'
import _definePage_default_40 from 'C:/source/faraadid/Frontend/src/pages/login.vue?definePage&vue'
import _definePage_default_41 from 'C:/source/faraadid/Frontend/src/pages/not-authorized.vue?definePage&vue'
import _definePage_default_42 from 'C:/source/faraadid/Frontend/src/pages/plugins/taraz-azmayeshi/list/index.vue?definePage&vue'
import _definePage_default_43 from 'C:/source/faraadid/Frontend/src/pages/register.vue?definePage&vue'
import _definePage_default_44 from 'C:/source/faraadid/Frontend/src/pages/validate-mobile-for-reset-password.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('C:/source/faraadid/Frontend/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('C:/source/faraadid/Frontend/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('C:/source/faraadid/Frontend/src/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'bot',
        /* internal name: 'apps-bot' */
        /* no component */
        children: [
          {
            path: 'chat',
            /* internal name: 'apps-bot-chat' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-chat-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/chat/[id].vue'),
                /* no children */
              },
  _definePage_default_4
  ),
              {
                path: 'only-charts',
                /* internal name: 'apps-bot-chat-only-charts' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'apps-bot-chat-only-charts-id',
                    component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/chat/only-charts/[id].vue'),
                    /* no children */
                  },
  _definePage_default_5
  )
                ],
              }
            ],
          },
          {
            path: 'connect-to-database',
            /* internal name: 'apps-bot-connect-to-database' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-connect-to-database-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/connect-to-database/[id].vue'),
                /* no children */
              },
  _definePage_default_6
  )
            ],
          },
          {
            path: 'connect-to-service',
            /* internal name: 'apps-bot-connect-to-service' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-connect-to-service-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/connect-to-service/[id].vue'),
                /* no children */
              },
  _definePage_default_7
  )
            ],
          },
          {
            path: 'conversation',
            /* internal name: 'apps-bot-conversation' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-conversation-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/conversation/[id].vue'),
                /* no children */
              },
  _definePage_default_8
  )
            ],
          },
          {
            path: 'dashboard',
            /* internal name: 'apps-bot-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-dashboard-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/dashboard/[id].vue'),
                /* no children */
              },
  _definePage_default_9
  )
            ],
          },
          {
            path: 'files',
            /* internal name: 'apps-bot-files' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-files-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/files/[id].vue'),
                /* no children */
              },
  _definePage_default_10
  ),
              {
                path: 'list',
                /* internal name: 'apps-bot-files-list' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'apps-bot-files-list-id',
                    component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/files/list/[id].vue'),
                    /* no children */
                  },
  _definePage_default_11
  )
                ],
              }
            ],
          },
          {
            path: 'list',
            /* internal name: 'apps-bot-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-bot-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/list/index.vue'),
                /* no children */
              },
  _definePage_default_12
  )
            ],
          },
          {
            path: 'monitoring',
            /* internal name: 'apps-bot-monitoring' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-monitoring-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/monitoring/[id].vue'),
                /* no children */
              },
  _definePage_default_13
  ),
              {
                path: 'list',
                /* internal name: 'apps-bot-monitoring-list' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'apps-bot-monitoring-list-id',
                    component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/monitoring/list/[id].vue'),
                    /* no children */
                  },
  _definePage_default_14
  )
                ],
              }
            ],
          },
          {
            path: 'my-dashboard',
            /* internal name: 'apps-bot-my-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-my-dashboard-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/my-dashboard/[id].vue'),
                /* no children */
              },
  _definePage_default_15
  ),
              {
                path: 'list',
                /* internal name: 'apps-bot-my-dashboard-list' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'apps-bot-my-dashboard-list-id',
                    component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/my-dashboard/list/[id].vue'),
                    /* no children */
                  },
  _definePage_default_16
  )
                ],
              }
            ],
          },
          {
            path: 'settings',
            /* internal name: 'apps-bot-settings' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-settings-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/settings/[id].vue'),
                /* no children */
              },
  _definePage_default_17
  )
            ],
          },
          {
            path: 'teaching',
            /* internal name: 'apps-bot-teaching' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-bot-teaching-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/teaching/[id].vue'),
                /* no children */
              },
  _definePage_default_18
  ),
              {
                path: 'list',
                /* internal name: 'apps-bot-teaching-list' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'apps-bot-teaching-list-id',
                    component: () => import('C:/source/faraadid/Frontend/src/pages/apps/bot/teaching/list/[id].vue'),
                    /* no children */
                  },
  _definePage_default_19
  )
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'chat',
        /* internal name: 'apps-chat' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-chat',
            component: () => import('C:/source/faraadid/Frontend/src/pages/apps/chat/index.vue'),
            /* no children */
          },
  _definePage_default_20
  )
        ],
      },
      {
        path: 'conversation',
        /* internal name: 'apps-conversation' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-conversation-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-conversation-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/conversation/list/index.vue'),
                /* no children */
              },
  _definePage_default_21
  )
            ],
          }
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'apps-dashboard' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-dashboard',
            component: () => import('C:/source/faraadid/Frontend/src/pages/apps/dashboard/index.vue'),
            /* no children */
          },
  _definePage_default_22
  )
        ],
      },
      {
        path: 'database-connection-data',
        /* internal name: 'apps-database-connection-data' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-database-connection-data-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-database-connection-data-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/database-connection-data/list/index.vue'),
                /* no children */
              },
  _definePage_default_23
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-database-connection-data-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-database-connection-data-view-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/database-connection-data/view/[id].vue'),
                /* no children */
              },
  _definePage_default_24
  )
            ],
          }
        ],
      },
      {
        path: 'database-type',
        /* internal name: 'apps-database-type' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-database-type-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-database-type-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/database-type/list/index.vue'),
                /* no children */
              },
  _definePage_default_25
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-database-type-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-database-type-view-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/database-type/view/[id].vue'),
                /* no children */
              },
  _definePage_default_26
  )
            ],
          }
        ],
      },
      {
        path: 'feedback',
        /* internal name: 'apps-feedback' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-feedback-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-feedback-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/feedback/list/index.vue'),
                /* no children */
              },
  _definePage_default_27
  )
            ],
          }
        ],
      },
      {
        path: 'file',
        /* internal name: 'apps-file' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-file-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-file-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/file/list/index.vue'),
                /* no children */
              },
  _definePage_default_28
  )
            ],
          }
        ],
      },
      {
        path: 'llm',
        /* internal name: 'apps-llm' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-llm-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-llm-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/llm/list/index.vue'),
                /* no children */
              },
  _definePage_default_29
  )
            ],
          }
        ],
      },
      {
        path: 'message',
        /* internal name: 'apps-message' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-message-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-message-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/message/list/index.vue'),
                /* no children */
              },
  _definePage_default_30
  )
            ],
          }
        ],
      },
      {
        path: 'monitoring',
        /* internal name: 'apps-monitoring' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-monitoring',
            component: () => import('C:/source/faraadid/Frontend/src/pages/apps/monitoring/index.vue'),
            /* no children */
          },
  _definePage_default_31
  )
        ],
      },
      {
        path: 'notification',
        /* internal name: 'apps-notification' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-notification-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-notification-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/notification/list/index.vue'),
                /* no children */
              },
  _definePage_default_32
  )
            ],
          }
        ],
      },
      {
        path: 'permissions',
        /* internal name: 'apps-permissions' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-permissions',
            component: () => import('C:/source/faraadid/Frontend/src/pages/apps/permissions/index.vue'),
            /* no children */
          },
  _definePage_default_33
  )
        ],
      },
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-roles',
            component: () => import('C:/source/faraadid/Frontend/src/pages/apps/roles/index.vue'),
            /* no children */
          },
  _definePage_default_34
  )
        ],
      },
      {
        path: 'settings',
        /* internal name: 'apps-settings' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-settings-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-settings-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/settings/list/index.vue'),
                /* no children */
              },
  _definePage_default_35
  )
            ],
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/user/list/index.vue'),
                /* no children */
              },
  _definePage_default_36
  )
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-user-view' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'apps-user-view-id',
                component: () => import('C:/source/faraadid/Frontend/src/pages/apps/user/view/[id].vue'),
                /* no children */
              },
  _definePage_default_37
  )
            ],
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('C:/source/faraadid/Frontend/src/pages/change-password.vue'),
    /* no children */
  },
  _definePage_default_38
  ),
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('C:/source/faraadid/Frontend/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_39
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('C:/source/faraadid/Frontend/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_40
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('C:/source/faraadid/Frontend/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_41
  ),
  {
    path: '/plugins',
    /* internal name: 'plugins' */
    /* no component */
    children: [
      {
        path: 'taraz-azmayeshi',
        /* internal name: 'plugins-taraz-azmayeshi' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'plugins-taraz-azmayeshi-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'plugins-taraz-azmayeshi-list',
                component: () => import('C:/source/faraadid/Frontend/src/pages/plugins/taraz-azmayeshi/list/index.vue'),
                /* no children */
              },
  _definePage_default_42
  )
            ],
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('C:/source/faraadid/Frontend/src/pages/register.vue'),
    /* no children */
  },
  _definePage_default_43
  ),
  _mergeRouteRecord(
  {
    path: '/validate-mobile-for-reset-password',
    name: 'validate-mobile-for-reset-password',
    component: () => import('C:/source/faraadid/Frontend/src/pages/validate-mobile-for-reset-password.vue'),
    /* no children */
  },
  _definePage_default_44
  )
]
